import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetLocationStoresParams } from './types'
import type { StoresDto } from './dtos'

const URL = '/location/stores/'

export const getStores: AblePaginatedResponseFn<GetLocationStoresParams, StoresDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
